import React from 'react';

export default class Support extends React.Component {
  render() {
    var styles = {
      position: 'fixed',
      right: 0,
      top: 300,
      transform: 'rotate(270deg) translateY(2rem)'
    };
    return <div style={ styles }>
      <button type='button' className='btn btn-info'>
        <i className='fa fa-life-ring'></i> Support
      </button>
    </div>;
  }
}
